import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// ── http → https biztosíték ──────────────────────────────────────────────────
// Az elsődleges védelem az nginx 301-e (frontend/nginx.conf), ez a második
// réteg: az nginx az upstream fejlécekből következtet a protokollra, itt
// viszont a böngésző MAGA mondja meg – így akkor is véd, ha a proxy-fejlécek
// hiányoznak vagy félrevezetnek.
//
// Miért fontos: http-n a lap betöltődik, de minden API-hívás elhasal (a
// backend CORS-allowlistája csak https origineket enged), és a látogató
// „nincs internetkapcsolat” hibát lát. A csere a React mountolása ELŐTT
// történik, ezért semmilyen kitöltött állapot nem vész el.
// A localhost és a prerender (puppeteer, szintén localhost) érintetlen.
if (
  typeof window !== "undefined" &&
  window.location.protocol === "http:" &&
  /(^|\.)norbiphone\.hu$/i.test(window.location.hostname)
) {
  window.location.replace(
    "https://" + window.location.host + window.location.pathname +
    window.location.search + window.location.hash
  );
}

const container = document.getElementById("root");

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// A prerenderelt markup (scripts/prerender.js) puppeteer DOM-SNAPSHOT, nem
// React szerver-render kimenet – hiányoznak belőle a hidrációs markerek
// (Suspense <!--$-->, szöveg-elválasztó <!-- -->). A hydrateRoot ezért minden
// oldalon #418-cal (mismatch) kliens-újrarenderre esett vissza (bizonyítás:
// Hydration Debug Sprint). Ugyanazt tesszük SZÁNDÉKOSAN és hibajelzés nélkül:
// a statikus HTML a SEO-t/first-paintet szolgálja, a JS betöltése után a
// friss kliens-render váltja (a csere időzítése azonos a korábbi, hibás
// hidráció-utáni regenerálással – vizuális változás nincs).
if (container.hasChildNodes()) container.innerHTML = "";
ReactDOM.createRoot(container).render(app);
